// Hide annons text if no ad is shown (due to no cookie consent for marketing)
const hideAdElements = () => {
    const innerContentAdElements = document.querySelectorAll(".content-ad__inner");
    const innerWidgetAdElements = document.querySelectorAll(".widget-ad__inner");
    let combinedAdElements = [];
    if (innerContentAdElements != null || innerWidgetAdElements != null) {
        const innerContentAdArr = Array.from(innerContentAdElements);
        const innerWidgetAdArr = Array.from(innerWidgetAdElements);
        combinedAdElements = innerContentAdArr.concat(innerWidgetAdArr);
  
        // Hide annons text if no ad is shown
        if (combinedAdElements.length > 0) {
            combinedAdElements.forEach(adElement => {
                if (adElement.children.length < 1) {
                    let adContainerEl = adElement.parentElement;
                    if (adContainerEl.classList.contains("content-ad") || adContainerEl.classList.contains("widget-ad")) {
                        adContainerEl.style.display = "none";
                    }
                }
            })
        }
    }
}

export default hideAdElements;